import { render, staticRenderFns } from "./SdcmFooter.vue?vue&type=template&id=0374fea6&scoped=true&"
import script from "./SdcmFooter.vue?vue&type=script&lang=js&"
export * from "./SdcmFooter.vue?vue&type=script&lang=js&"
import style0 from "./SdcmFooter.vue?vue&type=style&index=0&id=0374fea6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0374fea6",
  null
  
)

export default component.exports